import React, { useState } from 'react';

import IconEdit from '../../assets/images/common/icon-edit.svg';
import IconCopy from '../../assets/images/common/icon-copy.svg';

import { MasterPrefectureApiResponse } from '../../types/api/MasterPrefectureApiType';
import { MasterSlaApiResponse } from '../../types/api/MasterSlaApiType';
import { EstimateInquiry, SetStateEstimate } from '../../types/common/EstimateInquiryType';
import { ErrorMessages } from '../../types/common/Messages';

import { ErrorModalModal } from '../../components/ErrorModal';
import { EditEstimateRow } from '../../pages/EditEstimate/EditEstimateRow';

type ConfirmationEstimationProps = {
    estimateInquiry: EstimateInquiry;
    setState: SetStateEstimate;
    masterPrefecture: MasterPrefectureApiResponse;
    masterSla: Array<MasterSlaApiResponse>;
};

export const ConfirmationEstimation: React.FC<ConfirmationEstimationProps> = ({
    estimateInquiry,
    setState,
    masterPrefecture,
    masterSla,
}) => {
    // 入力切替
    const [inputMode, setInputMode] = useState<boolean>(false);
    // エラーモーダル制御 マイリストが10件以上となった場合のエラーモーダル
    const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);

    return (
        // 見積からの遷移の場合の表示
        <div className='columns separate_field'>
            <div className='column'>
                <div className='column-header'>
                    <h2>下記の機器に関する見積依頼</h2>
                    <button
                        className='button is-small editlist'
                        onClick={() => setInputMode(true)}
                        disabled={inputMode}
                    >
                        内容を修正する
                        <span className='icon is-small is-right'>
                            <img src={IconEdit} alt='' />
                        </span>
                    </button>
                </div>
                <div className='column-content'>
                    {estimateInquiry.estimatePatternList.map((estimatePattern, index) => {
                        return (
                            <div
                                key={`confirmationEstimation-estimatePatternList-${estimatePattern.estimatePatternRowNumber}-${index}`}
                            >
                                <EditEstimateRow
                                    setState={setState}
                                    rowNumber={index + 1}
                                    masterPrefecture={masterPrefecture}
                                    masterSla={masterSla}
                                    estimatePattern={estimatePattern}
                                    inputMode={inputMode}
                                    patternListLength={estimateInquiry.estimatePatternList.length}
                                    deviceList={estimateInquiry.deviceList}
                                />
                            </div>
                        );
                    })}
                    {inputMode ? (
                        <div className='edit-estimate-row-copy'>
                            <button
                                className='edit-estimate-row-copy-button'
                                onClick={setState.addStateEstimatePattern}
                            >
                                見積り条件追加
                                <span className='icon is-small copy-icon'>
                                    <img src={IconCopy} alt='' />
                                </span>
                            </button>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <ErrorModalModal
                openState={openErrorModal}
                setOpenState={setOpenErrorModal}
                contactShow
                errorMessages={[ErrorMessages.DEVICE_LIST_ADD_ERROR]}
                contactShowErrorMessage={ErrorMessages.DEVICE_LIST_ERROR_CONTACT}
            />
        </div>
    );
};
